var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('bo-user-list',{attrs:{"title":"Utilisateurs","subtitle":"Programme National","storePrefix":"user","routePrefix":"spiadi","keepLast":false,"parentAll":_vm.all}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }